module.exports = __webpack_public_path__ + "static/img/3.3874d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/3.png
// module id = 87Kr
// module chunks = 0